export enum HeaderType {
  Overview,
  Title,
  UserManagement,
  Analytics,
  EmailTemplates,
  Details,
}
